module.exports = __webpack_public_path__ + "img/energy_marker.svg";